import { pushToDataLayer } from '@/lib/pushToDataLayer.ts';

export const trackApplicationSubmitted = ({
  industry,
  position,
  hasLocation,
}: {
  industry: string;
  position: string;
  hasLocation: boolean;
}) => {
  pushToDataLayer({
    event: 'application_submitted',
    industry,
    position,
    has_location: hasLocation,
  });
};
